// Only set __webpack_public_path__ if window.LC_CDN is defined (standalone mode).
// In UISS mode, window.LC_CDN is not set, so we leave __webpack_public_path__ unchanged
// to let webpack use the default publicPath from the build config.
//
// IMPORTANT: This must be a plain JS file, not CoffeeScript.
// CoffeeScript wraps code in an IIFE which creates a local variable instead of
// assigning to webpack's global __webpack_public_path__.
if (window.LC_CDN) {
  __webpack_public_path__ = window.LC_CDN;
}
